export default __webpack_public_path__ + "static/media/emenu-logo-full.a35311c7.svg";